import { Immutable, toImmutable } from 'nuclear-js';

const store = 'runtime';

export const displaySettings = [store, 'displaySettings'];
export const transitionInfo = displaySettings.concat(['transitionInfo']);
export const isTransitionInProgress = transitionInfo.concat(['isTransitionInProgress']);
export const transitionType = transitionInfo.concat(['transitionType']);
export const transitionToSubject = transitionInfo.concat(['newSubject']);
export const selectedSubject = displaySettings.concat(['selectedSubject']);
export const preferredSubject = displaySettings.concat(['preferredSubject']);
export const expandedModule = displaySettings.concat(['expandedModule']);

export const subjects = [store, 'subjects'];
export const popoverTermNumber = [store, 'popoverTermNumber'];
export const modules = [store, 'modules'];
export const studentTransitionAction = [store, 'studentTransitionAction'];
export const openHelpBoxId = displaySettings.concat(['openHelpBoxId']);
export const gradeDropdownOpen = displaySettings.concat(['gradeDropdownOpen']);
export const appLevelCssClassName = displaySettings.concat(['appLevelCssClassName']);
export const studentListOpen = displaySettings.concat(['studentListOpen']);
export const OpenModalDialogId = displaySettings.concat(['OpenModalDialogId']);
export const showHighlights = displaySettings.concat(['showHighlights']);
export const singleStudentSearchRendering = [store, 'displaySettings', 'singleStudentSearchRendering'];
export const pageAlert = [store, 'pageAlert'];
export const animationIsRunning = displaySettings.concat(['animationIsRunning']);
export const selectedGoals = [
    [store, 'filters', 'selectedGoals'],
    selectedSubject,
    (goals, selectedSubject) => {
        return goals.getIn([selectedSubject.get('bid')], Immutable.List());
    },
];

export const selectedGoalsForCurrentStudent = (subjectBid) => {
    return [
        [store, 'filters', 'selectedGoals'],
        (goals) => {
            return goals.getIn([subjectBid], Immutable.List());
        },
    ];
};
export const selectedComparisonPeriod = (subjectBid) => {
    return [
        [store, 'filters', 'selectedComparisonPeriod'],
        (periods) => {
            return periods.get(subjectBid, null);
        },
    ];
};
export const selectedQuadrantChartRotation = [store, 'filters', 'quadrantChartRotation'];
export const unsavedData = [store, 'unsavedDataState', 'unsavedData'];
export const unsavedDataState = [store, 'unsavedDataState'];
export const modalReferences = [store, 'modalReferences'];

export const allowAdvanceStudent = [
    [store, 'allowAdvanceStudent'],
    [store, 'initialLoadDone'],
    (allowAdvanceStudent, initialLoadDone) => {
        return allowAdvanceStudent && initialLoadDone;
    },
];
export const userAction = [store, 'userAction'];

export default {
    fullStore: [store],
    allowAdvanceStudent,
    animationIsRunning,
    appLevelCssClassName,
    displaySettings,
    expandedModule,
    gradeDropdownOpen,
    isTransitionInProgress,
    modalReferences,
    modules,
    openHelpBoxId,
    OpenModalDialogId,
    pageAlert,
    popoverTermNumber,
    preferredSubject,
    selectedComparisonPeriod,
    selectedGoals,
    selectedGoalsForCurrentStudent,
    selectedQuadrantChartRotation,
    selectedSubject,
    showHighlights,
    singleStudentSearchRendering,
    studentListOpen,
    studentTransitionAction,
    subjects,
    transitionInfo,
    transitionToSubject,
    transitionType,
    unsavedData,
    unsavedDataState,
    userAction,
};
